export default [
  {
    path: '/active-zhuaniu/index',
    name: 'index',
    component: () => import('@/views/active-zhuaniu'),
    meta: {
      title: '春节抓牛，赢学习礼物-高考直通车'
    }
  },
  
]
